import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import classes from './BulletinSection.module.css';

interface BulletinSectionProps {
  readonly title: ReactNode;
  /** Ссылка справа от заголовка, например «Все сделки». */
  readonly link?: { readonly to: string; readonly label: string };
  /** Произвольное содержимое справа от заголовка: кнопка-ссылка, пометка «Ваш ход». */
  readonly aside?: ReactNode;
  /** Отступ между заголовком и содержимым. На «Главной» строки начинаются сразу под линией. */
  readonly spaced?: boolean;
  readonly children: ReactNode;
}

/** Раздел без рамки: заголовок с зелёной линией снизу и содержимое (язык «Бюллетеня»). */
export default function BulletinSection({ title, link, aside, spaced = false, children }: BulletinSectionProps) {
  return (
    <section>
      {/* Ссылка и пометка справа стоят рядом с заголовком, а не внутри него: элемент управления в <h2> программа
          чтения с экрана зачитала бы как часть названия раздела. */}
      <div className={classes.head}>
        <h2 className={classes.title}>{title}</h2>
        {link ? (
          <Link to={link.to} className={classes.link}>
            {link.label}
          </Link>
        ) : null}
        {aside}
      </div>
      {spaced ? <div className={classes.body}>{children}</div> : children}
    </section>
  );
}
